import { Button } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { handleMarcarActaComoImpresa } from "./handlers";
import { marcarActaComoImpresaSchema } from "./schemas";
import { MuniSpinner2 } from "../../../../components";
import useActas from "../../../../api/actas";

const FormMarcarActaComoImpresa = ({acta, setActa, setRefetch}) => {
  // const { acta, setActa,  } = props;
  const { marcarActaImpresa } = useActas();

  //FECHA Y HORA UTC-3 (ARGENTINA): new Date(new Date().getTime() - (3 * 60 * 60 * 1000)).toISOString().slice(0, 19);
  const methods = useForm({
    resolver: yupResolver(marcarActaComoImpresaSchema),
    defaultValues: {
      fecha_impresion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 19),
      id_acta: acta.id,
    },
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit((data) => {
        marcarActaImpresa(data,setRefetch)
      }
      )}>
        <fieldset disabled={methods.formState.isSubmitting} className="d-flex flex-column gap-3">
          <div>
            <label>Fecha de impresión *</label>
            <input
              {...methods.register("fecha_impresion")}
              step={1}
              type="datetime-local"
              className={
                "form-control " +
                (methods.formState.errors["fecha_impresion"] ? " border border-danger " : "")
              }
            />
            {methods.formState.errors["fecha_impresion"] ? (
              <small className="fw-semibold text-danger">
                {methods.formState.errors["fecha_impresion"]["message"]}
              </small>
            ) : null}
          </div>

          <Button
            type="submit"
            disabled={methods.formState.isSubmitting}
            style={{
              height: "38px",
              alignSelf: "end",
              marginBottom: methods.formState.errors?.dominio ? "29px" : "",
            }}
          >
            {methods.formState.isSubmitting ? (
              <span className="d-flex gap-1">
                <MuniSpinner2
                  width="18px"
                  height="18px"
                  circularProgressSize={24}
                  circularProgressColor="#ffffff"
                  fileName="bola-blanca.png"
                />
              </span>
            ) : (
              "Marcar como impresa"
            )}
          </Button>
        </fieldset>
      </form>
    </FormProvider>
  );
};

export default FormMarcarActaComoImpresa;
